"use client"

import { Trash } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `TrashIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const TrashIcon = component(Icon)({ as: Trash })
